export default __webpack_public_path__ + "static/media/deleteIcon.4cf85250.png";